import { heroStats } from '@/mocks/comicData';

export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[560px] w-full flex-col justify-center overflow-hidden md:min-h-[640px]">
      <img
        src="https://readdy.ai/api/search-image?query=Cozy%20mysterious%20old%20general%20store%20interior%20at%20night%20bathed%20in%20warm%20amber%20lantern%20light%2C%20wooden%20shelves%20lined%20with%20curious%20vintage%20items%20and%20weathered%20books%2C%20soft%20glowing%20paper%20lanterns%2C%20stylized%20painterly%20storybook%20illustration%20for%20a%20healing%20fantasy%20manga%2C%20rich%20warm%20orange%20and%20deep%20brown%20palette%2C%20atmospheric%20cozy%20mood%2C%20gentle%20magical%20dust%20in%20the%20air%2C%20high%20detail&width=1600&height=900&seq=hero-store-night&orientation=landscape"
        alt="深夜亮着暖黄灯光的洞洞杂货铺内景插画"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80" />

      <div className="relative mx-auto w-full max-w-7xl px-4 py-20 md:px-6 md:py-24">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-100/30 bg-background-100/10 px-4 py-1.5 text-sm text-background-100 backdrop-blur-sm">
            <i className="ri-sparkling-2-line" />
            奇幻治愈系 · 深夜杂货铺物语
          </span>
          <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-white md:text-5xl">
            洞洞杂货铺漫画
            <span className="mt-2 block text-xl font-bold text-background-100 md:text-2xl">
              一段旧物，一缕执念，一页温暖
            </span>
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
            深夜巷子里的神秘杂货铺没有标价，只以「旧物换心愿」。主角小满误入其中，在一位位客人的故事里，读懂人心的执念与放下。这里为你汇总《洞洞杂货铺漫画》的剧情全解析：分卷剧情、角色脉络、结局走向，一页看完。
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#intro"
              className="whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              开始了解剧情
              <i className="ri-arrow-right-line ml-1.5" />
            </a>
            <a
              href="#volumes"
              className="whitespace-nowrap rounded-full border border-background-100/40 bg-background-100/10 px-7 py-3 text-sm font-medium text-background-100 backdrop-blur-sm transition-colors hover:bg-background-100/20"
            >
              查看分卷剧情
            </a>
          </div>
        </div>

        <div className="mx-auto mt-12 grid max-w-3xl grid-cols-2 gap-3 sm:grid-cols-4">
          {heroStats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-background-100/20 bg-background-100/10 px-4 py-4 text-center backdrop-blur-sm"
            >
              <div className="font-heading text-2xl font-black text-accent-300 md:text-3xl">{stat.value}</div>
              <div className="mt-1 text-xs text-background-100/80">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}